import React from "react";
import ReactApexChart from "react-apexcharts";
import "../CompanyNameChart/CompanyNameChart.css";

const CompanyNameChart = () => {
  // Updated data for Empty, Mismatched, and Perfect Companies
  const series = [50, 20, 70]; // Values for Empty, Mismatched, and Perfect Companies
  const options = {
    // chart: {
    //   // type: "radialBar",
    // },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "30%",
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
        barLabels: {
          enabled: true,
          useSeriesColors: false,
          offsetX: -12,
          fontSize: "14px",
          color: "#999", // Set the label text color to #999
          // formatter: function (seriesName, opts) {
          //   return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
          // },
        },
      },
    },
    colors: ["#404dad", "#6e7ad4", "#efc58a"], // Updated with your specific colors
    labels: ["Empty Company", "Mismatched Company", "Perfect Company"], // Updated labels
    tooltip: {
      enabled: true,
      formatter: function (val, { seriesIndex }) {
        const label = options.labels[seriesIndex];
        return `${label}: ${val}%`;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  return (
    <>
      <section className="section">
        <div className="company-container">
          <div className="company-header">
            <h1>Company Name Categories <sub style={{color: "blue"}}>(RadialBar Chart)</sub></h1>
          </div>

          <div className="company-parent">
            <div className="company-count-wrapper">
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#5662be" }}></i>{" "}
                Empty
              </div>
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#7a86df" }}></i>{" "}
                Mismatched
              </div>
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#efc58a" }}></i>{" "}
                Perfect
              </div>
            </div>

            <div className="company-chart-container">
              <ReactApexChart
                options={options}
                series={series}
                type="radialBar"
                height={330}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyNameChart;
